<template>
  <div
    v-if="vMemorialHallDetailed.MemorialHallSearchApiModel != null"
    class="memorialhall"
  >
    <!-- header start -->
    <van-nav-bar
      :title="vMemorialHallDetailed.MemorialHallSearchApiModel.Title"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      <template #left >
        <van-icon name="arrow-left" />
        <div class="home-nav" @click.stop="onHome" >
          <img class="home-icon" src="@/assets/images/home.png" >
        </div>
      </template>
      <template #right>
        <van-icon name="share" @click="shareHandler" />
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <img
      v-if="vMemorialHallDetailed.Template"
      :src="vMemorialHallDetailed.Template.CoverPhoto"
      class="memorialhall_bg"
    />
    <img
      v-else
      src="@/assets/images/memorialhall_bg/default.jpg"
      class="memorialhall_bg"
    />

    <div
      id="desc"
      style="display:none"
      v-html="
        vMemorialHallDetailed.MemorialHallSearchApiModel
          .DeceasedInformationApiModelList[0].LifeIntroduction
      "
    ></div>
    <section class="my-swipe-panel">
      <div class="topfun">
        <div class="total" @click="onGoFirenList">
          <div class="overlay">
            &nbsp;
          </div>
          <div class="content2">
            <!-- <van-image
              round
              width="1.5rem"
              height="1.5rem"
              :src="vMemorialHallDetailed.MemberHeadPic"
            /> -->
            <van-image
              round
              width="1.5rem"
              height="1.5rem"
              :src="
                vMemorialHallDetailed.MemorialHallSearchApiModel
                  .DeceasedInformationApiModelList[0].HeadPhoto
              "
            />
            <div class="people2">
              <van-icon name="friends-o" />
              <div class="text">
                {{ vMemorialHallDetailed.FriendCount }}个人
              </div>
            </div>
          </div>
        </div>

        <div class="headBox" v-if="frienList != null">
          <div class="pic" v-for="(item, index) in frienList" :key="index">
            <van-image
              round
              width="2rem"
              height="2rem"
              :src="item.HeadPic"
            ></van-image>
          </div>
        </div>

        <div class="join" @click="onJoinR">加入亲友团</div>
      </div>

      <div
        style="display: flex;justify-content: center;position: relative;
    top: 30px;font-weight: 600;font-size: 16px;z-index: 999;"
      >
        <router-link :to="'/Cemetery?id=' + id">网上墓园</router-link>
        <div style="margin:0 5px;">|</div>
        <router-link :to="'/Worship?id=' + id">网上纪念堂</router-link>
      </div>
      <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
        <van-swipe-item>
          <div class="memorialhall01">
            <div class="content">
              <!-- 单人头像 -->
              <div
                class="singleContent"
                v-if="
                  vMemorialHallDetailed.MemorialHallSearchApiModel
                    .DeceasedInformationApiModelList.length <= 1
                "
              >
                <van-image
                  width="145"
                  height="186"
                  fit="cover"
                  radius="4"
                  :src="
                    vMemorialHallDetailed.MemorialHallSearchApiModel
                      .DeceasedInformationApiModelList[0].HeadPhoto
                  "
                />
                <div class="name">
                  {{
                    vMemorialHallDetailed.MemorialHallSearchApiModel
                      .DeceasedInformationApiModelList[0].DeceasedName
                  }}
                </div>
                <P class="date"
                  >{{
                    vMemorialHallDetailed.MemorialHallSearchApiModel
                      .DeceasedInformationApiModelList[0]
                      .OutPutBirthdayDateDesc
                  }}-{{
                    vMemorialHallDetailed.MemorialHallSearchApiModel
                      .DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc
                  }}</P
                >
              </div>
              <!-- 双人头像 -->
              <div class="doubleContent" v-else>
                <div
                  v-for="item in vMemorialHallDetailed
                    .MemorialHallSearchApiModel.DeceasedInformationApiModelList"
                  :key="item.SerialNumber"
                >
                  <div class="item">
                    <van-image
                      width="120"
                      height="152"
                      fit="cover"
                      radius="4"
                      :src="item.HeadPhoto"
                    />
                    <div class="name">{{ item.DeceasedName }}</div>
                    <P class="date"
                      >{{ item.OutPutBirthdayDateDesc }}-{{
                        item.OutPutPassAwayDateDesc
                      }}</P
                    >
                  </div>
                </div>
              </div>
              <div class="des">
                <div v-html="departedSketch"></div>
              </div>
              <div class="totalView">
                已有
                <span class="corange">{{
                  vMemorialHallDetailed.MemorialHallSearchApiModel.ClickCount
                }}</span
                >次纪念
              </div>
            </div>
            <!-- 等级 -->
            <div
              v-if="
                vMemorialHallDetailed.MemorialHallSearchApiModel
                  .MemorialHallLevel > 1 &&
                  vMemorialHallDetailed.LevelAppLogo != ''
              "
              class="leftContent"
            >
              <img
                :src="vMemorialHallDetailed.LevelAppLogo"
                class="gradeIcon"
              />
            </div>

            <div class="rightContent">
              <div
                class="musicBtn"
                :class="{ musicBtnPlay: musicBtnPlay }"
                @click="clickmusic()"
              ></div>
              <!-- @click="$store.commit('toggleMusicState','#audio')" -->
              <!-- <div class="musicBtn">
                <aplayer autoplay mini repeat="repeat-one"
                  :music="{
                    title: 'secret base~君がくれたもの~',
                    artist: 'Silent Siren',
                    src: 'http://www.jq22.com/demo/vuekgbfq202003082021/xs.mp3',
                  }"
                  ref="player"
                />
              </div>-->

              <div
                v-if="currentToken.isLogin"
                class="item"
                @click="clickfollow"
              >
                <van-icon
                  v-if="
                    vMemorialHallDetailed.MemorialHallSearchApiModel.IsFollow
                  "
                  name="like"
                  color="red"
                  class="active"
                />
                <van-icon v-else name="like-o" color="#fff" />
              </div>

              <!-- 模板处理 -->
              <router-link
                v-if="
                  currentToken.isLogin && vMemorialHallDetailed.IsSelf == true
                "
                class="item"
                :to="{
                  path: '/TemplateList',
                  query: {
                    id: this.$route.query.id,
                    keyName: 'MemorialHallTemplate',
                    mid:
                      vMemorialHallDetailed.MemorialHallSearchApiModel
                        .MemorialHallID,
                    placeType: placeType,
                    templateid:
                      vMemorialHallDetailed.MemorialHallSearchApiModel
                        .MemorialHallAppBuyTemplateId,
                  },
                }"
              >
                <van-icon name="apps-o" color="#fff" />
              </router-link>
              <router-link
                v-if="
                  currentToken.isLogin && vMemorialHallDetailed.IsSelf == true
                "
                :to="{
                  name: 'HallInfoEdit',
                  params: {
                    id:
                      vMemorialHallDetailed.MemorialHallSearchApiModel
                        .MemorialHallID,
                  },
                }"
                class="item"
              >
                <van-icon name="edit" color="#fff" />
              </router-link>
              <router-link
                v-if="
                  currentToken.isLogin && vMemorialHallDetailed.IsSelf == true
                "
                :to="{
                  path: '/MemorialHallSet',
                  query: { id: this.$route.query.id },
                }"
                class="item"
              >
                <van-icon name="setting-o" color="#fff" />
              </router-link>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="memorialhall02">
            <div
              v-for="item in vMemorialHallDetailed.MemorialHallSearchApiModel
                .DeceasedInformationApiModelList"
              :key="item.SerialNumber"
              class="sz-info"
            >
              <p>姓名:{{ item.DeceasedName }}</p>
              <p>性别:{{ item.Sex }}</p>
              <p>籍贯:{{ item.OriginalhomeAddress }}</p>
              <p>生辰:{{ item.OutPutBirthdayDateDesc }}</p>
              <p>忌日:{{ item.OutPutPassAwayDateDesc }}</p>
              <p>生肖:{{ item.Zodiac }}</p>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="memorialhall03">
            <p>
              您是第
              <span class="corange">{{
                vMemorialHallDetailed.MemorialHallSearchApiModel.ClickCount
              }}</span
              >位前来吊唁的人。
            </p>
            <p class="des">
              今天是公历{{
                $moment(vMemorialHallDetailed.CurrentTime).format("YYYY-MM-DD")
              }}，{{ vMemorialHallDetailed.WeekCn }};
              <br />
              {{ vMemorialHallDetailed.LunarCalendar }}。
            </p>

            <p
              class="box"
              v-for="item in vMemorialHallDetailed.MemorialHallSearchApiModel
                .DeceasedInformationApiModelList"
              :key="item.SerialNumber"
            >
              {{ item.DeceasedName }}已经离开我们
              <span class="corange">{{ item.LeaveDay }}</span
              >天;
              <br />
              {{
                item.PassAwayDateTime
                  ? $moment(item.PassAwayDateTime).format("YYYY-MM-DD")
                  : ""
              }}是{{ item.DeceasedName }}的忌日; <br />距今还有
              <span class="corange">{{ item.DeathDay }}</span
              >天。
            </p>
          </div>
        </van-swipe-item>
      </van-swipe>

    </section>


    <div @click="isWorshipShow = !isWorshipShow" class="jibaiBtn">祭拜</div>
    <transition name="van-slide-down">
      <div v-show="isWorshipShow" class="worshipBtn">
        <router-link :to="'/Worship?id=' + id" class="btn jiayuanBtn"
          >家园</router-link
        >
        <router-link :to="'/Cemetery?id=' + id" class="btn fudiBtn"
          >福地</router-link
        >
      </div>
    </transition>
    <!-- <router-link to="/BookingGoodsList" class="daijiBtn">预约代祭</router-link> -->
    <!-- <vue-seamless-scroll
        class="sao-list"
        :class-option="classOption"
      >
        <ul id="img-list">
          <li
            v-for="(item, index) in sacrificeLogList"
            :key="index"
          >
            <div class="sao-list-a">
              <img
                :src="item.HeadPic"
                width="200"
                height="200"
                :alt="item.NickName"
              />
            </div>
            <div class="sao-list-b">
              <span style="color: #eb9904; ">{{ item.NickName }}</span>
              <span style="color: #ffffff; ">{{ item.Desc }}</span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll> -->
      <!-- <test></test> -->
      <sacrificeLog :mid="id" ></sacrificeLog>
    <div class="visit-box">
      <van-row gutter="10">
        <van-col
          span="4"
          v-for="item in vMemorialHallDetailed.VisitCalleApiModelList"
          :key="item.id"
          @click="goPersonInfo(item.MemberApiModel.SerialNumber)"
        >
          <div class="item">
            <van-image
              round
              width="70%"
              height="70%"
              fit="cover"
              :src="item.MemberApiModel.HeadPic"
            />
          </div>
        </van-col>
        <!-- <van-col v-if="vMemorialHallDetailed.IsMore" span="4" @click="goVisitorList">
          <div class="item">
            <van-icon name="ellipsis" size="28" />
          </div>
        </van-col> -->
        <van-col
          v-if="vMemorialHallDetailed.IsMore"
          span="4"
          @click="goVisitorList"
        >
          <div class="item">
            <van-icon name="ellipsis" size="28" />
          </div>
        </van-col>
      </van-row>
    </div>

    <!-- <van-overlay :show="overShow" @click="overShow = false" /> -->
    <van-popup v-model:show="overShow" position="bottom">
      <joinR @hideEvent="onHideJoinR"></joinR>
    </van-popup>
  </div>
</template>
<script>
import soshm from "soshm";
/*import Aplayer from 'vue-aplayer';*/
import VueMoment from "vue-moment";
import { mapGetters, mapState } from "vuex";
import pstatus from "@/static/sacrificePlaceTypeStatus";
import { Toast } from "vant";
import wx from "weixin-js-sdk";
import auth from "../../tools/auth.js";
import joinR from "@/components/JoinR.vue";
import sacrificeLog from "@/components/sacrificeLog.vue";

export default {
  data() {
    return {
      // isPlaying: true,
      isWorshipShow: false,
      vMemorialHallDetailed: {},
      departedSketch: "",
      isFollow: false,
      placeType: 0,
      id: 0,
      musicBtnPlay: true,
      overShow: false,
      frienList: null,
    };
  },
  computed: {
    ...mapGetters(["currentToken"]),
    ...mapState({
      musicList: (state) => state.home.musicList,
    })
  },
  components: {
    joinR,
    sacrificeLog
  },
  deactivated: function() {
    this.isWorshipShow = false;
  },
  methods: {
    init(id) {
      var that = this;
      this.id = id;
      var options = {
        type: "GetMemorialHallSearchApiById",
        id: id,
      };
      that.$store.dispatch(options).then((res) => {
        // console.log(res, "res");
        if (res.MemorialHallSearchApiModel.IsPrivacy) {
          var _id = res.MemorialHallSearchApiModel.SerialNumber;
          auth.IsFriend(this, _id);
        }
        that.isFollow = res.MemorialHallSearchApiModel.IsFollow;
        that.vMemorialHallDetailed = res;
        if (res.MemorialHallSearchApiModel) {
          that.$store.commit(
            "setmid",
            res.MemorialHallSearchApiModel.SerialNumber
          );
          that.$store.commit(
            "setmuid",
            res.MemorialHallSearchApiModel.MemorialHallID
          );
        }

        var deceasedInformation =
          res.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0];
        if (
          deceasedInformation.DepartedSketch != null &&
          deceasedInformation.DepartedSketch != ""
        ) {
          if (deceasedInformation.DepartedSketch.length > 20) {
            this.departedSketch = deceasedInformation.DepartedSketch.substring(
              0,
              19
            );
          } else {
            this.departedSketch = deceasedInformation.DepartedSketch;
          }
        } else {
          this.departedSketch = "死亡不是生命的终点 <br/> 遗忘才是生命的终结";
        }
        if (that.$weixin.IsWeiXin()) {
          that.initweixinShare();
        }
      });
    },
    getFrienMemberTeamList() {
      var that = this;
      var _mid = this.$route.query.id;
      this.$store
        .dispatch({
          type: "GetFrienMemberTeamSList",
          mid: _mid
        })
        .then((res) => {
          that.frienList = res.data;
        });
    },
    getIsFriend(mid, callBack) {
      this.$store
        .dispatch({
          type: "MemorialHallIsFriend",
          mid: mid,
        })
        .then((res) => {
          callBack(res);
        });
    },
    onClickLeft() {
      // this.$router.go(-1);
      // if(window.history.length > 1){
      //     window.history.go( -1 );
      // }else{
      //     window.location.href = "/";
      // }
      this.$back();
    },
    /**推荐给朋友**/
    shareHandler() {
      //this.$weixin.ShareWeiXinAppMessage("title","描述");
      if (this.$weixin.IsWeiXin()) {
        soshm.weixinSharetip();
      } else {
        Toast("当前暂不支持分享");
      }
    },
    goVisitorList() {
      this.$router.push("/VisitorList?id=" + this.id);
    },
    goPersonInfo(id) {
      this.$router.push("/PersonInfo?id=" + id);
    },
    clickfollow() {
      //addFollowMemorialHall
      var that = this;
      this.$store
        .dispatch({
          type: "addFollowMemorialHallVue",
          IsAuth: true,
          MId:
            that.vMemorialHallDetailed.MemorialHallSearchApiModel
              .MemorialHallID,
        })
        .then(
          (res) => {
            Toast(res.Message);
            if (res.IsSuccess) {
              that.vMemorialHallDetailed.MemorialHallSearchApiModel.IsFollow =
                res.Information == "true";
            }
          },
          (error) => {}
        );
    },
    /* clickMusicPlay(){
        if(!this.isPlaying){
          //this.$refs.player.play()
          this.isPlaying = true;
          console.log('播放-----');
        }else{
          this.$refs.player.pause()
          this.isPlaying = false;
          console.log('暂停-----');
        }
      },*/
    initweixinShare() {
      var that = this;
      this.$nextTick(() => {
        let desc = document.querySelector("#desc").innerText;
        if (!desc) {
          desc = that.vMemorialHallDetailed.MemorialHallSearchApiModel.Title;
        }
        that.$weixin.ShareWeiXinAppMessage(
          that.vMemorialHallDetailed.MemorialHallSearchApiModel.Title,
          desc,
          that.vMemorialHallDetailed.MemorialHallSearchApiModel
            .DeceasedInformationApiModelList[0].HeadPhoto
        );
      });
    },
    initMusic() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetMusicInfoManageDefaultMusic",
          MemorialHallId: that.id,
        })
        .then(
          (res) => {
            let oAudio = document.querySelector("#audio");
            if (oAudio.src != res.DefaultMusic) {
              oAudio.src = res.DefaultMusic;
            }
            that.$nextTick(() => {
              that.$store.state.isPlaying = true;
            });
          },
          (err) => {}
        );
    },
    clickmusic() {
      this.$store.state.isPlaying = !this.$store.state.isPlaying;
      this.$store.commit("setPlayControl", {
        id: this.$route.query.id,
        play: this.$store.state.isPlaying,
      });
      this.$store.state.playControl[
        this.$route.query.id
      ].play = this.$store.state.isPlaying;
      let oAudio = document.querySelector("#audio");
      this.$store.state.isPlaying ? oAudio.play() : oAudio.pause();
      this.musicBtnPlay = this.$store.state.isPlaying;
    },
    onJoinR() {
      console.log(this.vMemorialHallDetailed);
      if(this.vMemorialHallDetailed.IsSelf){
        this.$router.push("/frienShare?id="+this.vMemorialHallDetailed.MemorialHallSearchApiModel.SerialNumber)
      }
      else{
        this.overShow = true;
      }
      
    },
    onHideJoinR(state) {
      this.overShow = state;
    },
    onGoFirenList() {
      var id = this.$route.query.id;
      this.$router.push("/frienMemberTeam?mid=" + id);
    },
    onHome(){
      this.$router.push("/Home");
    }
  },
  activated() {
    // var that=this;
    var id = this.$route.query.id;
    this.placeType = pstatus.MemorialHall;

    this.init(id);
    this.getFrienMemberTeamList();
    this.musicBtnPlay =
      this.$store.state.playControl[id] == undefined
        ? true
        : this.$store.state.playControl[id].play;
    // this.initMusic();
  },
  created() {
    // var id = this.$route.query.id;
    // this.placeType = pstatus.MemorialHall;
    // this.init(id);
    //console.log(id);
    //console.log(this.musicList);
  },
};
</script>
<style scoped>
.memorialhall {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  width: 100%;
  height: 100%;
}
.memorialhall_bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 50px;
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.my-swipe-panel {
  height: 100%;
  padding-bottom: 96px;
  position: relative;
}

.topfun {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  top: 10px;
  .admin {
    img {
      height: 35px;
      border-radius: 26px;
    }
  }
  .headBox {
    display: flex;
    flex-direction: row;
    padding-left: 8px;
    .pic {
      display: flex;
      padding-left: 2px;
      align-items: center;
      img {
        height: 35px;
        border-radius: 26px;
      }
    }
  }
  .total {
    display: flex;
    /* background-color: black; */
    color: white;
    /* min-width: 80px; */
    border-radius: 8px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* opacity: 0.5; */
    padding: 5px;
    overflow: hidden;
    position: relative;
    left: 5px;
    .overlay {
      display: block;
      height: 100%;
      width: 100%;
      background-color: black;
      position: absolute;
      opacity: 0.3;
    }
    .content2 {
      display: flex;
      align-items: center;
      flex-direction: column;
      z-index: 2;

      img {
        height: 35px;
        border-radius: 26px;
      }
    }
  }

  .people2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    .text {
      padding-left: 3px;
      font-size: 12px;
    }
  }

  .join {
    margin-left: 5px;
    display: flex;
    background-color: #44b86d;
    color: white;
    min-width: 100px;
    height: 30px;
    border-radius: 10px;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
}

.my-swipe {
  height: 100%;
  width: 100%;
}
.memorialhall01 {
  position: relative;
}
.memorialhall01 > .leftContent {
  position: absolute;
  top: 4%;
  left: 10px;
}
.memorialhall01 > .leftContent > .gradeIcon {
  width: 46px;
  height: 46px;
  object-fit: contain;
}
.memorialhall01 > .rightContent {
  position: absolute;
  top: 8%;
  right: 10px;
}
.memorialhall01 > .rightContent > .item {
  width: 30px;
  height: 30px;
  background-color: #24a378;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.memorialhall01 .content {
  padding: 0 20px;
}
.memorialhall01 .content .des {
  text-align: center;
  font-size: 14px;
  margin-top: 14px;
}
.memorialhall01 .content .totalView {
  text-align: center;
  font-size: 14px;
  margin-top: 4px;
}
.memorialhall01 > .rightContent > .musicBtn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 10;
  background: url("~@/assets/images/worship/musicBtn.png") center no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}
.musicBtnPlay {
  -webkit-animation: mymove 1.5s infinite linear;
  animation: mymove 1.5s infinite linear;
}
@-webkit-keyframes mymove {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes mymove {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.singleContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10%;
}
.singleContent > .name {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 6px;
}
.singleContent > .date {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.doubleContent {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 25%;
}
.doubleContent > div > .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 130px;
  overflow: hidden;
  margin: 0 10px;
}
.doubleContent > div > .item > .name {
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  margin-top: 6px;
}
.doubleContent > div > .item > .date {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.memorialhall02 > .sz-info {
  margin: 8% 30px;
}
.memorialhall02 > .sz-info > p {
  font-size: 15px;
  text-align: left;
}
.memorialhall03 {
  padding: 8% 30px;
}
.memorialhall03 > p {
  font-size: 15px;
  text-align: left;
}
.memorialhall03 > .des {
  margin-top: 20px;
}
.memorialhall03 > .box {
  background-color: rgba(0, 0, 0, 0.08);
  margin: 4px 0;
  padding: 6px;
}
.memorialhall01,
.memorialhall02,
.memorialhall03 {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 85px;
}
.jibaiBtn {
  position: fixed;
  right: 15px;
  bottom: 135px;
  width: 56px;
  height: 56px;
  line-height: 56px;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  color: #fff;
  z-index: 9;
}
.visit-box {
  position: fixed;
  right: 0;
  bottom: 40px;
  z-index: 8;
  width: 100%;
  padding: 10px 10px;
}
.visit-box .item {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.worshipBtn {
  position: fixed;
  right: 15px;
  bottom: 191px;
  z-index: 10;
}
.worshipBtn .btn {
  display: block;
  width: 50px;
  height: 50px;
  font-size: 15px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  background-color: #eee;
  border-radius: 50%;
}
.jiayuanBtn {
  background-color: green !important;
  box-shadow: 0 1px 2px green;
}
.fudiBtn {
  background-color: orange !important;
  box-shadow: 0 1px 2px orange;
}
.daijiBtn {
  position: fixed;
  right: 15px;
  bottom: 201px;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  text-align: center;
  font-size: 13px;
  color: #fff;
  z-index: 8;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 6px;
}
</style>
<style>
/*
.musicBtn .aplayer-pic .aplayer-button{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 10;
  background: url('~@/assets/images/worship/musicBtn.png') center no-repeat;
  background-size: 100% 100%;
  border:0 none;
  position: relative;
  bottom: 0 !important;
  right: 0 !important;
}
.musicBtn .aplayer-pic .aplayer-play{
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  right: 0;
  margin: 0;
}
.musicBtn .aplayer-icon{
  display: none !important;
}
.musicBtn .aplayer-pic .aplayer-button.aplayer-pause{
  -webkit-animation: mymove 1.5s infinite linear;
  animation: mymove 1.5s infinite linear;
}
.musicBtnPlay {
    -webkit-animation: mymove 1.5s infinite linear;
    animation: mymove 1.5s infinite linear;
}
@-webkit-keyframes mymove {
from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
}
to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
}
}
@keyframes mymove {
from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
}
to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
}
}
.musicBtn .aplayer.aplayer-narrow{
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  z-index: 10;
  background: none;
  background-size: 100% 100%;
  margin:0 0 10px;
}
.musicBtn .aplayer-pic{
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  z-index: 10;
  background-image: none !important;
  background: url('~@/assets/images/worship/musicBtn.png') center no-repeat;
  background-size: 100% 100%;
}*/

.home-nav{
  display: flex;
  align-items: center;
  .home-icon{
  width: 30px;
  height: 30px;

}
}


.sao-list{bottom: 153px !important}
/* .sao-list ul{ margin: 0px; padding: 0px; }
.sao-list li{ 
	position: relative;  width: 227px; height: 36px; background-image: url("../../assets/images/zy/list-bg.png");
	background-repeat: no-repeat; float: left; font-size: 14px; margin-top: 6px; z-index: 100;
	overflow: hidden;
}
.sao-list-a{width: 30px; height: 30px; position:absolute;  left:3px; top: 3px;  }
.sao-list-a  img{width: 30px; height: 30px;  border-radius: 100px;  }
.sao-list-b { position:absolute;  left:40px; top:8px; } */

</style>
<style>
.van-overlay {
  z-index: 99 !important;
}
</style>
